export const enum MutationNames {
  updatePatientWithExerciseSummarys = 'PATIENT_WITH_EXERCISE_SUMMARYS_UPDATE_PATIENT_WITH_EXERCISE_SUMMARYS',
}

export const enum ActionNames {
  getPatientWithExerciseSummarys = 'PATIENT_WITH_EXERCISE_SUMMARYS_GET_PATIENT_WITH_EXERCISE_SUMMARYS',
}

export const enum GetterNames {
  patientWithExerciseSummarys = 'PATIENT_WITH_EXERCISE_SUMMARYS_PATIENT_WITH_EXERCISE_SUMMARYS',
  patientWithExerciseSummarysOrderedByFullName = 'PATIENT_WITH_EXERCISE_SUMMARYS_PATIENT_WITH_EXERCISE_SUMMARYS_ORDERED_BY_FULL_NAME',
}
